function put<T extends { id: string }>(list: T[], item: T): T[] {
  return list.map(listItem => (listItem.id === item.id ? item : listItem));
}

export { put };
